<div class="p-4">
  <div class="container">
    <h1 i18n>Welcome, {{account?.name}}!</h1>
    <p i18n>Choose from the menu items.</p>
  </div>
</div>
